type ListOfDealersTypes = {
  [key: string]: string[];
};

const listOfDealers: ListOfDealersTypes = {
  MTL: [
    'Audi Anjou',
    'Audi Blainville',
    'Audi Lauzon',
    'Audi Popular',
    'Audi St-Bruno',
    'Audi St. Laurent',
    'Audi West Island',
    'Park Avenue Audi',
  ],
  GTA: [
    'Audi Brampton',
    'Audi Downtown Toronto',
    'Audi Durham',
    'Audi Midtown Toronto',
    'Audi Oakville',
    'Audi Mississauga',
    'Audi Queensway',
    'Audi Thornhill',
    'Audi Uptown',
    'HJ Pfaff Motors',
    'Pfaff Audi',
  ],
  VAN: [
    'Audi Boundary',
    'Audi Downtown Vancouver',
    'Audi Langley',
    'Audi Richmond',
    'Capilano Audi',
  ],
  ALB: ['Audi Royal Oak', 'Southgate Audi', 'Audi Edmonton North', 'Glenmore Audi'],
};

export const zipClusterMap = {
  AK: 'Alaska',
  AL: 'Alabama',
  AR: 'Arkansas',
  AZ: 'Arizona',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  IA: 'Iowa',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  MA: 'Massachusetts',
  MD: 'Maryland',
  ME: 'Maine',
  MI: 'Michigan',
  MN: 'Minnesota',
  MO: 'Missouri',
  MS: 'Mississippi',
  MT: 'Montana',
  NC: 'North Carolina',
  ND: 'North Dakota',
  NE: 'Nebraska',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NV: 'Nevada',
  NY: 'New York',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  USA: 'National',
  UT: 'Utah',
  VA: 'Virginia',
  VT: 'Vermont',
  WA: 'Washington',
  WI: 'Wisconsin',
  WV: 'West Virginia',
};

export default listOfDealers;
